<template>
  <section id="main">
  <div class="container contact">
    <div class="row gtr-200">
      <div class="col-12 contact__wrapper">
        <!-- Highlight -->
        <section class="box highlight">
          <header>
            <h2>{{ $t('contact') }}</h2>
          </header>
          <div class="row">
            <p class="contact__description">
                {{ $t('contact_description') }}
            </p>
            <ul class="business-contact">
                <li class="business-contact__item">
                    <span><i class="fas fa-phone-square-alt"></i> {{ BUSINESS_INFO.PHONE_NUMBER }}</span>
                </li>
                <li class="business-contact__item">
                    <span><i class="fas fa-fax"></i> {{ BUSINESS_INFO.FAX }}</span>
                </li>
                <li class="business-contact__item">
                    <span><i class="fas fa-envelope-square"></i> {{ BUSINESS_INFO.EMAIL }}</span>
                </li>
            </ul>
          </div>
        </section>
        <ContactForm/>
      </div>
    </div>
  </div>
</section>
</template>

<script>
import ContactForm from '@/components/ContactForm.vue'

export default {
  name: 'Contact',
  components: {
    ContactForm
  },
  data () {
    return {
      BUSINESS_INFO: {
        PHONE_NUMBER: '916 716 496',
        FAX: '916 601 006',
        EMAIL: 'talleres@radiadorescoslada.com'
      }
    }
  },
  methods: {
    send () {
    }
  }
}
</script>

<style lang='less' scoped>
    .box {
     margin-bottom: 3em;
     &__description {
         margin: 5px auto;
     }
    }
    .contact {
        &__description {
            margin: 7px auto;
        }
    }

    .business-contact {
        margin: 0 auto;
        padding-top: 10px;
        &__item {
            list-style: none;
            text-align: left;
            display: inline;
            margin-left: 1em;
        }
    }

    @media only screen and (max-width: 980px) {
    .box, .contact-form.row {
      padding: 10px;
    }

    .business-contact {
        &__item {
        display: block;
        width: 100%;
        text-align: center;
        margin-left: 0;
      }
    }
  }

</style>
